import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';

type Notice = { id: number; message: string; tone: 'info' | 'error' };
type StatusContextValue = { notify: (message: string, tone?: Notice['tone']) => void };
const StatusContext = createContext<StatusContextValue | null>(null);

export function StatusProvider({ children }: { children: ReactNode }) {
  const [notice, setNotice] = useState<Notice | null>(null);
  const notify = useCallback((message: string, tone: Notice['tone'] = 'info') => setNotice({ id: Date.now(), message, tone }), []);
  useEffect(() => {
    if (!notice) return undefined;
    const timer = window.setTimeout(() => setNotice(null), 6000);
    return () => window.clearTimeout(timer);
  }, [notice]);
  return <StatusContext.Provider value={{ notify }}>
    {children}
    {notice && <div role="status" className={`fixed bottom-5 right-5 z-[100] max-w-[min(90vw,36rem)] rounded-lg border px-4 py-3 text-sm shadow-2xl ${notice.tone === 'error' ? 'border-rose-500/50 bg-[#241116] text-rose-200' : 'border-slate-600 bg-[#131a25] text-slate-100'}`}>{notice.message}</div>}
  </StatusContext.Provider>;
}

export function useStatus(): StatusContextValue {
  const value = useContext(StatusContext);
  if (!value) throw new Error('useStatus must be used inside StatusProvider');
  return value;
}
